export default __webpack_public_path__ + "static/media/clickable.8631aaab.cur";